import { Dialog } from "@headlessui/react";
import { forwardRef } from "react";
import UiDialog, { UiDialogInputProps } from "./UiDialog";
import classNames from "classnames";

const FullscreenUiDialog = forwardRef<typeof Dialog, UiDialogInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <UiDialog
        ref={ref}
        className={classNames(
          className,
          "absolute bottom-0 left-0 right-0 top-0 rounded-none",
        )}
        {...props}
      ></UiDialog>
    );
  },
);

export default FullscreenUiDialog;
